import React from 'react';
import {connect} from 'react-redux';
import {BaseDashboard} from '../base-dashboard';

class Dashboard extends BaseDashboard {
    render() {
        const keyPlayersQuantity = this.getKeyPlayersQuantity();
        const lineupsQuantity = this.getLineupsQuantity();

        return (
            <div className="lineups-info-holder">
                <ul className="lineups-info">
                    <li>
                        <strong>{keyPlayersQuantity}</strong> QB Used
                    </li>
                    <li>
                        <strong>{lineupsQuantity}</strong> Lineups
                    </li>
                </ul>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        filterLineupsByCorrelationStackCombinations,
        lineupsData: {rawLineups},
    } = state;

    return {
        rawLineups,
        filterLineupsByCorrelationStackCombinations,
    };
}

export default connect(mapStatesToProps)(Dashboard);
